/**
 * Ce qui distingue réellement les trois examens nationaux.
 *
 * Le reste — inscription, dépôt de pièces, encaissement, suivi du dossier —
 * est identique et vit dans `SectionExamen`. Trois fichiers d'un millier de
 * lignes chacun ne différaient que par les libellés ci-dessous et, pour le
 * BEPC, par une exclusion de classes.
 */

export const EXAMENS_NATIONAUX = {
  CEPE: {
    code: 'CEPE',
    libelleLong: 'CEPE',
    nomComplet: "Certificat d'Études Primaires Élémentaires",
    libelleClasses: 'CM2'
  },

  BEPC: {
    code: 'BEPC',
    libelleLong: 'BEPC',
    nomComplet: "Brevet d'Études du Premier Cycle",
    // Les classes P3 ne présentent pas le BEPC : c'est le serveur qui les
    // écarte (NIVEAUX dans ExamenService), ou le paramétrage des examens quand
    // l'école y a coché ses classes. Le navigateur ne filtre plus de son côté.
    libelleClasses: '3ème'
  },

  BAC: {
    code: 'BAC',
    libelleLong: 'BACCALAURÉAT',
    nomComplet: 'Baccalauréat',
    libelleClasses: 'Terminale'
  }
};

export default EXAMENS_NATIONAUX;
